import React from 'react';
import { Stack, Typography } from '@mui/material';
import { MdError } from "react-icons/md";
import { Link } from 'react-router-dom';


import Modal from "../../components/uiComponent/modal/index";
import AgGrid from "../../components/ag-grid-table/index";
import Badge from '../../components/uiComponent/bages';

import { convertUtcToEst } from "../../utils/helpers.js";

import { MappingAlertWrapper } from './style';

import { capitalize } from 'lodash';

const defaultColDef = {
  resizable: true,
  sortable: false,
  filter: false,
  flex: 1,
};

const ROW_HEIGHT = 40;
const HEADER_HEIGHT = 32;
// Keep a comfortable minimum height for a few work orders, and cap it (the grid then
// scrolls internally) so a SKU linked to many work orders can't blow up the modal.
const MIN_GRID_HEIGHT = 300;
const MAX_GRID_HEIGHT = 480;

const MappingAlert = ({ showMappingAlert, setShowMappingAlert, rowData, errorMessage }) => {
  const columnDefs = [
    {
      headerName: 'Order Name',
      cellRenderer: ({ data }) => {
        const { order_name, id, status } = data?.work_orders_v2 || {};

        return (
          <Link
            to={status === 'Confirmed' ? `/confirm-placement/${id}` : `/inventory/work-order/${id}`}
            style={{ fontSize: '12px', fontWeight: '400', color: '#1565D8', width: '100%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}
            target='_blank'
            hrefLang='https//:www.google.com'
          >
            {order_name || '---'}
          </Link>
        );
      }
    },
    {
      headerName: 'Active Date',
      cellRenderer: ({ data }) => {
        const { created_at } = data?.work_orders_v2 || {};

        return (
          <Typography fontSize={12} fontWeight={400} color="#4E5969">{convertUtcToEst(created_at, { month: '2-digit', day: '2-digit', year: 'numeric' })}</Typography>
        );
      }
    },
    {
      headerName: 'Status',
      headerClass: 'parent-header',
      width: 100,
      cellRenderer: ({ data }) => {
        const { status } = data?.work_orders_v2 || {};
        return (
          <Badge text={status} status={capitalize(status) || 'N/A'} />
        )
      }
    },
  ];

  const handleCloseModal = () => {
    setShowMappingAlert(false);
  };

  // Fit the grid to its rows (header + rows + a small buffer), clamped between a
  // comfortable minimum and a max — beyond the max the grid scrolls internally.
  const rowCount = rowData?.length || 1;
  const contentHeight = HEADER_HEIGHT + rowCount * ROW_HEIGHT + 8;
  const gridHeight = Math.min(Math.max(contentHeight, MIN_GRID_HEIGHT), MAX_GRID_HEIGHT);

  return (
    <Modal
      removeIcon
      open={showMappingAlert}
      onHide={handleCloseModal}
      onClose={handleCloseModal}
    >
      <MappingAlertWrapper>
        <Typography component="h6" fontSize="18px" fontWeight={700} color="#1565D8" marginTop={2}>Mapping Alert</Typography>
        <Stack direction="row" marginBottom={2} marginTop={1} spacing={0.5}>
        <MdError style={{fontSize: '16px', color: 'red'}} />
        <Typography component="h6" fontSize="12px" fontWeight={700} color="red">{errorMessage || '---'}</Typography>
        </Stack>
        <AgGrid
          user_referrals={rowData}
          defaultColDef={defaultColDef}
          columnDefinitions={columnDefs}
          rowHeight={ROW_HEIGHT}
          headerHeight={HEADER_HEIGHT}
          containerHeight={`${gridHeight}px`}
        />
      </MappingAlertWrapper>
    </Modal>
  )
}

export default MappingAlert